import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogWrapperComponent } from '../dialog-wrapper/dialog-wrapper.component';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@Services/auth.service';

@Component({
    selector: 'login-request-dialog',
    imports: [CommonModule, DialogWrapperComponent, TranslateModule],
    templateUrl: './login-request-dialog.component.html',
    styleUrls: ['./login-request-dialog.component.scss']
})
export class LoginRequestDialogComponent {

  @ViewChild('dialog')
  protected dialog!:DialogWrapperComponent;

  @Output()
  protected close: EventEmitter<void> = new EventEmitter();

  constructor(
    private authSvc: AuthService
  ) { }

  public emitEvent() {
    this.close.emit();
  }

  public showModal(){
    this.dialog.showModal();
  }

  public closeModal(){
    this.dialog.close();
  }

  public gotoLogin(){
    this.authSvc.oauthLogout();
    this.authSvc.login();
  }

  public logoutAndKeepBrowsing(){
    this.authSvc.logout(true);
    this.dialog.close();
  }
}
